<template>
  <default-layout>
    <template slot="top">
      <h1 class="title mt-1">Matieres</h1>
    </template>
    <template slot="center">
      <div class="white-card">
        <div class="loader absolute" v-if="loading && !subjects.length"></div>
        <div class="row m-3 ">
          <div class="col-md-4 mb-4" v-for="(subject,i) in subjects" :key="i">
            <subject-v2 :subject="subject"></subject-v2>
          </div>
        </div>
      </div>
    </template>
  </default-layout>
</template>

<script>
import SubjectV2 from "../components/Subject/SubjectViewV2";
import LeftSidebarBottom from '../components/LayoutPartials/LeftSideBarBottom'
import {mapGetters} from 'vuex'
import DefaultLayout from "@/Layout/DefaultLayout";

export default {
  name: "SubjectsPage",
  components: {
    DefaultLayout,
    LeftSidebarBottom,
    SubjectV2,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      'loading': 'subject/loading',
      'subjects': 'subject/subjects'
    })
  },
  mounted() {
    this.$store.dispatch('subject/fetchClassroomSubjects')
  }
}
</script>

<style lang="scss">
</style>
